<div data-testid="serial-profile-page" class="p-6 serial-profile-container flex-table-page">
  <!-- Header -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">
      {{ "settings.serial_profile.title" | translate }}
    </h2>
  </div>
  <!-- Search Form -->
  <app-search-form
    data-testid="serial-profile-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'serial-profile-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      @if (canCreate()) {
        <app-button
          [testId]="'serial-profile-add-btn'"
          [label]="'common.actions.new' | translate"
          type="info"
          (emitOnClick)="onAdd()"
        ></app-button>
      }
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="serial-profile-table"
      #advancedTable
      [dataSource]="filteredProfiles()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="rows"
      [first]="page() * rows"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
    <!-- Custom Template for Required Fields and Date -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (
        column &&
        (column.prop === "lotRequired" ||
          column.prop === "expiryRequired" ||
          column.prop === "serialRequired")
      ) {
        <div class="flex items-center justify-center">
          <p-tag
            [attr.data-testid]="
              'serial-profile-required-tag-' +
              column.prop +
              '-' +
              rowData.id
            "
            [value]="
              value
                ? ('common.options.yes' | translate)
                : ('common.options.no' | translate)
            "
            [severity]="value ? 'success' : 'danger'"
            styleClass="status-tag"
            size="small"
          />
        </div>
      } @else if (column && column.prop === "creationDate") {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(rowData?.creationDate || value) }}
        </span>
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status let-rowData="rowData">
      <div class="flex items-center justify-center gap-1 w-full">
        <p-tag
          [attr.data-testid]="'serial-profile-status-tag-' + rowData.id"
          [value]="getStatusDisplayText(rowData.status)"
          [severity]="getStatusSeverity(rowData.status)"
          styleClass="status-tag"
          size="small"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      @if (canUpdate()) {
        <div class="flex gap-2 justify-center">
          <app-button
            [testId]="'serial-profile-action-edit-' + rowData.id"
            class="action-edit"
            [label]="'common.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          ></app-button>
        </div>
      }
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="serial-profile-toast"></p-toast>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  data-testid="serial-profile-confirmation-dialog"
  [(visible)]="showConfirmationDialog"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
